import { Alert, Snackbar } from "@mui/material";


interface SnackbarProps {
    msg: string;
    onClose: () => void;
    severity: "success" | "info" | "warning" | "error";
    open: boolean;
    autoHideDuration?: number
}


const MySnackbar = (props: SnackbarProps) => {

    const handleClickAwayClose = (event: React.SyntheticEvent | Event, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        props.onClose()
    };

    return (
        <Snackbar
            open={props.open}
            autoHideDuration={props.autoHideDuration || 3000}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
            onClose={handleClickAwayClose}
            style={{zIndex: 1400}}
        >
            <Alert severity={props.severity} variant="filled" onClose={props.onClose}>
                {props.msg}
            </Alert>
        </Snackbar>
    );
}

export default MySnackbar;